import React from 'react';
import NewsSourceLink from './NewsSourceLink';

const NewsTechPick = ({ pick, source }) => {
  if (!pick?.title) return null;
  return (
    <section className="news-section" aria-labelledby="news-tech-title">
      <h2 id="news-tech-title" className="news-section-title">테크 한 스푼</h2>
      <div className="news-card news-tech">
        <h3 className="news-item-title">{pick.title}</h3>
        {pick.point && <p className="news-item-why">{pick.point}</p>}
        <NewsSourceLink source={source} />
      </div>
    </section>
  );
};

export default NewsTechPick;
